import { NameTxt } from "./Name.styles.js";
import { PCont } from "./Personal.styles.js";

const Name = () => {
  return (
    <PCont>
      <NameTxt>Pablo Mesquida</NameTxt>
    </PCont>
  );
};

export default Name;
